"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ChevronsmallrightGreyOutline = _interopRequireDefault(require("@druva-apps/orion-icons/lib/ChevronsmallrightGreyOutline"));

var _spinner = _interopRequireDefault(require("../../spinner/spinner"));

var _excluded = ["expandable", "expanded", "indentSize", "depth", "onExpand", "rowData", "rowIndex"];

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ExpandIcon = function ExpandIcon(_ref) {
  var expandable = _ref.expandable,
      expanded = _ref.expanded,
      indentSize = _ref.indentSize,
      depth = _ref.depth,
      onExpand = _ref.onExpand,
      rowData = _ref.rowData,
      rowIndex = _ref.rowIndex,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var handleClick = (0, _react.useCallback)(function (e) {
    e.stopPropagation();
    e.preventDefault();
    onExpand({
      expanded: expanded,
      rowData: rowData
    });
  }, [onExpand, expanded, rowData]);
  /* istanbul ignore if */
  // if (!expandable && indentSize === 0) {
  //   return null;
  // }

  var iconStyle = {
    transform: "rotate(".concat(expandable && expanded ? 90 : 0, "deg)"),
    transition: "transform 0.15s ease-out",
    width: "24px",
    height: "24px"
  };

  if (expandable || rowData && rowData.shouldExpand) {
    return /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({}, rest, {
      "aria-label": "Expand Row",
      type: "button",
      onClick: (expandable || rowData && rowData.shouldExpand) && onExpand ? handleClick : null,
      className: "oui-d-block orion-data-grid__row-cell--expand-icon"
    }), expanded && (!rowData || !rowData.children) ? /*#__PURE__*/_react["default"].createElement(_spinner["default"], {
      size: "sm",
      className: "oui-align-middle"
    }) : /*#__PURE__*/_react["default"].createElement(_ChevronsmallrightGreyOutline["default"], {
      inheritFontColor: true,
      size: "md",
      style: iconStyle
    }));
  }

  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, rest, {
    href: "#",
    className: "oui-d-block orion-data-grid__row-cell--expand-icon"
  }));
};

ExpandIcon.defaultProps = {
  depth: 0,
  indentSize: 16
};
ExpandIcon.propTypes = {
  expandable: _propTypes["default"].bool,
  expanded: _propTypes["default"].bool,
  indentSize: _propTypes["default"].number,
  depth: _propTypes["default"].number,
  onExpand: _propTypes["default"].func,
  rowIndex: _propTypes["default"].number,
  rowData: _propTypes["default"].object
};
var _default = ExpandIcon;
exports["default"] = _default;